import { useMemo } from "react"
import { differenceInSeconds } from "date-fns"
import { TGenericTimelineEvent, TGenericTimelineLabel } from "../GenericTimeline/GenericTimeline"
import { groupBy } from "../../../utils/arrayUtils"
import { useStyletron } from "baseui"
import { TimeSeriesStatisticsItem } from "../TimeSeriesStatisticsItem"


const GenericTimeseriesStatistics = (props: { data: TGenericTimelineEvent[], start: Date, end: Date, labels: TGenericTimelineLabel[], currentValue: any }) => {
    const [css, theme] = useStyletron()
    const dataIn = (props.data && props.data.length > 0 ) ? props.data : [{ value: props.currentValue,startDate: props.start, endDate: props.end  }];

    const data = useMemo(() => {
        const grouped = groupBy(dataIn, 'value');
        const timeRange = differenceInSeconds(props.end, props.start);

        const x = grouped.map((v) => {
            const duration = v.values.reduce((partialSum, a) => partialSum + (a.endDate.getTime() - a.startDate.getTime()), 0);
            const durationSec = duration / 1000;
            return {
                value: v.key,
                count: v.values.length,
                duration: duration,
                percentage: (durationSec / timeRange * 100).toFixed(1)
            }
        });
        return x.sort((a, b) => a.value - b.value);
    }, [dataIn])

    return (
        <ul
            className={css({
                paddingLeft: 0,
                paddingRight: 0,
            })}
        >
            {data?.map((v) =>
            <TimeSeriesStatisticsItem 
                    color={getLabelForValue(v.value, props.labels)?.color ?? theme.colors.accent}
                    percentage={Number(v.percentage) ?? 0}
                    count={v.count}
                    label={getLabelForValue(v.value, props.labels)?.label ?? 'undefined'} 
                    duration={v.duration}            
                    ></TimeSeriesStatisticsItem>
            )}
        </ul>
    )
}

export default GenericTimeseriesStatistics;

function getLabelForValue(value: any, labels: TGenericTimelineLabel[]) {
    const label = labels.find(v => v.value === value);
    return label;
}